const pageTitleMap = {
  '/admin-console': 'Merch Vendors Dashboard',
  '/admin-console/feature-flags': 'Feature Flags',
  '/admin-console/permissions': 'Role-Based Permissions',
  '/dashboard': 'Vendor Dashboard',
  '/sell-to-us': 'Sell to Us',
  '/sample-tags': 'Sample Tags',
  '/profile': 'Vendor Profile',
  'influencer-payee-information': 'Influencer Payee Information',
  'influencer-user-info': 'Influencer User Info',
  '/purchase-orders': 'Purchase Orders',
  '/requested-items': 'Requested Items',
  '/invoices': 'Invoices',
  '/credits': 'Bill Credits',
  '/payments': 'Bill Payments',
  '/factories': 'Factories',
  '/fn-catalog': 'FN Catalog',
  '/admin-console/vendor-init': 'Vendor Invite',
  '/social-media-console': 'Influencer Dashboard',
  '/admin-console/public-files': 'File Manager',
  '/deliveries': 'Deliveries',
  '/delivery-management': 'Warehouse settings',
  '/team-members': 'Team Members',
  '/sample-requests': 'Sample Requests',
};

/**
 * Map URLs to corresponding page titles based on the predefined mapping.
 * @param {string} url - The URL to map.
 * @returns {string} - The corresponding page title.
 *
 * Example usage:
 * const title = urlToTitle('/dashboard');
 * console.log(title);
 * // Output: 'Vendor Dashboard'
 */
const urlToTitle = (url) => {
  const mappedUrls = Object.keys(pageTitleMap);

  const foundUrl = mappedUrls.find((mappedUrl) => url.includes(mappedUrl));
  if (foundUrl) return pageTitleMap[foundUrl];
  return 'Fashion Nova Vendor Portal';
};

export default urlToTitle;
